import React, { forwardRef } from 'react';
import { PolymorphicRef } from '@mofid-securities/uikit';
import Button from '@/components/Button';
import { classnames } from '@/utils/classnames';
import type {
  IHorizontalTabProps,
  THorizontalTabValue,
} from './HorizontalTab.types';

export const HorizontalTab = forwardRef(
  <TValue extends THorizontalTabValue = THorizontalTabValue>(
    {
      isSelected,
      isVisible = true,
      onClick,
      children,
      className,
      disabled = false,
      ...rest
    }: IHorizontalTabProps<TValue>,
    ref: PolymorphicRef<'button'>
  ): JSX.Element | null => {
    return isVisible ? (
      <Button
        ref={ref}
        className={classnames(
          'flex-1 !rounded-none !border-b-2 !bg-transparent !px-1 !py-2 !text-sm font-medium',
          !isSelected &&
            'border-transparent !text-gray-filled-tertiary-enabled',
          isSelected &&
            '!border-mofidblue-solid-primary-enabled !text-mofidblue-filled-primary-enabled',
          className
        )}
        disabled={disabled}
        variant="default"
        onClick={onClick}
        {...rest}
      >
        {children}
      </Button>
    ) : null;
  }
) as <TValue extends THorizontalTabValue = THorizontalTabValue>(
  __props: IHorizontalTabProps<TValue> & { ref?: PolymorphicRef<'button'> }
) => JSX.Element | null;

// @ts-ignore
HorizontalTab.displayName = 'HorizontalTab';
